<template>
    <div class="contact">
        <div class="ct_title">请留下您的联系方式，我们将第一时间与您沟通</div>
        <div class="ct_block">
            <div class="ct_bleft">
                <div class="ct_bltitle">联系我们</div>
                <a-form :form="form" @submit="handleSubmit">
                    <a-form-item>
                    <a-input
                    class="ct_blipt"
                        v-decorator="['name', { rules: [{ required: true, message: '请输入姓名!' }] }]"
                        placeholder="请输入您的姓名"
                    >
                    </a-input>
                    </a-form-item>
                    <a-form-item>
                    <a-input
                    class="ct_blipt"
                        v-decorator="['phone', { rules: [{
                        required: true,
                        message: '请输入手机号!'
                        }, {
                        validator: checktelphone,
                        }] }]"
                        placeholder="请输入您的手机号"
                    >
                    </a-input>
                    </a-form-item>
                    <div class="btns">
                    <a-form-item>
                        <a-button type="primary" class="ct_blbtn" html-type="submit">
                        信息提交
                        </a-button>
                    </a-form-item>
                    </div>
                </a-form>
                <div id="captcha" />
                <!-- <div class="ct_blipt">
                    <input type="text" placeholder="请输入您的姓名" maxlength="8" />
                </div>
                <div class="ct_blipt">
                    <input type="tel" v-model="phone" placeholder="请输入您的手机号" maxlength="11" />
                </div>
                <div class="ct_blbtn">信息提交</div> -->
            </div>
            <div class="ct_brig">
                <div class="ct_bltitle2">即刻沟通</div>
                <div class="ct_blcimg"></div>
                <div class="ct_blsubtitle">扫码咨询</div>
            </div>
        </div>
    </div>
</template>

<script>
import { simpleInformationCollection } from '@/apis/index'
export default {
  name: 'ConsultForm',
  props: {
    title: {
      type: String,
      default: '咨询服务 立即预约'
    },
    infoSources: {
      type: String,
      default: '汇通数科官网-首页'
    },
    isIndex:{
        type: Boolean,
        default: false
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'connact' }),
      captchaIns: null,
      params: null
    }
  },
  computed: {
    getCrumbs() {
      return this.$store.state.Breadcrumb.crumbsList
    }
  },
  mounted() {
    this.getCode()
  },
  methods: {
    checktelphone(rule, value, callback) {
      const reg = /^1[3456789]\d{9}$/
      if (value && !(reg.test(value))) {
        callback('请输入正确的手机号码！')
      } else {
        callback()
      }
    },
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.captchaIns.popUp()
          this.params = {
            infoSources: this.infoSources,
            officialWebsiteEntrance: 'PC',
            name: values.name,
            phone: values.phone
          }
        }
      })
    },
    getCode() {
      const that = this
      // eslint-disable-next-line no-undef
      initNECaptcha && initNECaptcha({
        element: '#captcha',
        captchaId: '6c0483e901164a789d9d13f0291ba257',
        mode: 'popup',
        width: '320px',
        // enableClose: true,
        onClose: function() {
          // 弹出关闭结束后将会触发该函数
        },
        onVerify: function(err, data) {
          if (err) return
          that.params.pictureCode = data.validate
          simpleInformationCollection(that.params).then(res => {
            that.$message.success('感谢您的信息提交，我们将会有专员与您联系~')
            that.captchaIns.refresh()
            that.form.resetFields()
          }).catch(err => {
            that.$message.error(err)
            that.captchaIns.refresh()
          })
        }
      }, function(instance) {
        // 初始化成功后得到验证实例instance，可以调用实例的方法
        that.captchaIns = instance
      }, function(err) {
        console.log(err)
        // 初始化失败后触发该函数，err对象描述当前错误信息
      })
    }
  }
}
</script>

<style lang="less" scoped>
.ct_blcimg1{width: 200px;height: 200px;margin:20px auto;
    background-size: 100% 100%;
    background: url("../../src/assets/images/home/2023/contact-code1.png") no-repeat center;
    background-size: 100% 100%;}
.ct_blcimg{width: 200px;height: 200px;margin:20px auto;

    background: url("../../src/assets/images/home/2023/contact-code.jpeg") no-repeat center;
    background-size: 100% 100%;}
.ct_blsubtitle{height: 22px;
    font-size: 16px;
    font-weight: 400;text-align: center;
    color: #333333;
    line-height: 22px;}
    .contact{height: 612px;overflow: hidden;background: url("../../src/assets/images/home/2023/contact-bg.png") no-repeat center;}
    .ct_block{width: 1200px;height: 400px;margin:0 auto;background: #FFFFFF;
        border-radius: 6px;}
    .ct_title{height: 42px;
        font-size: 30px;
        font-weight: 500;margin-top:60px;margin-bottom: 50px;
        color: #FFFFFF;text-align: center;
        line-height: 42px;}
    .ct_bleft{width: 680px;height: 400px;float:left;overflow:hidden;background: linear-gradient(43deg, #F4F9FF 0%, #ECF4FE 61%, #E5F0FD 100%);}
    .ct_brig{width: 520px;height: 400px;float:left;overflow:hidden;}
    .ct_bltitle{
        height: 35px;text-align: center;
        font-size: 24px;
        font-weight: 500;
        color: #333333;
        line-height: 35px;margin-top:40px;margin-bottom: 40px;
    }
.ct_bltitle2{
    height: 35px;text-align: center;
    font-size: 24px;
    font-weight: 500;
    color: #333333;
    line-height: 35px;margin-top:40px;
}
    .ct_blipt{
        width: 500px;
        height: 50px;overflow: hidden;margin:0 auto;
        background: #FFFFFF;
        border-radius: 6px;
        border: 1px solid #E2E2E2;margin-bottom: 15px;
    }
    .ct_blipt input{height: 30px;line-height: 30px;margin-top:10px;background: none;outline: none;border:none;
        width: 100%;text-indent: 10px;color: #CCCCCC;font-size: 16px;
    }
    .ct_blbtn{width: 500px;
        height: 58px;cursor: pointer;
        background: #3986FF;
        border-radius: 6px;font-size: 23px;
        font-weight: 400;margin:0 auto;
        color: #FFFFFF;text-align: center;
        line-height: 58px;}
    .ct_blbtn:hover{box-shadow: 0px 0px 10px #ccc;}
    /deep/.ant-form-explain {
    /* line-height: 38px; */
    text-align: left;
    margin-left: 100px;
}
</style>
